// assets/brawn.js
gsap.registerPlugin(ScrollTrigger);

// --- MOUSE TRAIL LOGIC (SUBTLE) ---
const colors = ["#A63C2E", "#4ECDC4", "#E6BE8A", "#F5F5F0"];
let lastX = 0;
let lastY = 0;

document.addEventListener('mousemove', (e) => {
    const dist = Math.hypot(e.clientX - lastX, e.clientY - lastY);
    if (dist > 40) { 
        createDot(e.clientX, e.clientY);
        lastX = e.clientX;
        lastY = e.clientY;
    }
});

function createDot(x, y) {
    const dot = document.createElement('div');
    dot.classList.add('cursor-dot');
    dot.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
    dot.style.left = x + 'px';
    dot.style.top = y + 'px';
    document.body.appendChild(dot);
    setTimeout(() => dot.remove(), 800);
}

// --- SCROLL LOGIC ---
const initScroll = () => {
    if (window.innerWidth > 768) {
        const container = document.querySelector(".horizontal-container");
        const panels = gsap.utils.toArray(".panel");
        const beans = gsap.utils.toArray(".floating-bean");

        gsap.to(panels, {
            xPercent: -100 * (panels.length - 1),
            ease: "none",
            scrollTrigger: {
                trigger: ".horizontal-container",
                pin: true,
                scrub: 1,
                snap: 1 / (panels.length - 1),
                end: () => "+=" + container.offsetWidth,
                invalidateOnRefresh: true
            }
        });

        beans.forEach((bean) => {
            const speed = parseFloat(bean.getAttribute('data-speed')) || 1;
            gsap.to(bean, {
                x: () => window.innerWidth * 5 * speed,
                rotation: 720 * speed,
                ease: "none",
                scrollTrigger: {
                    trigger: ".horizontal-container",
                    start: "top top",
                    end: () => "+=" + container.offsetWidth,
                    scrub: 1
                }
            });
        });
    }
};

window.addEventListener('load', initScroll);

let width = window.innerWidth;
window.addEventListener("resize", () => {
    if (window.innerWidth !== width) {
        width = window.innerWidth;
        ScrollTrigger.getAll().forEach(st => st.kill());
        initScroll();
    }
});

function scrollToSection(index) {
    const container = document.querySelector(".horizontal-container");
    const totalScroll = container.offsetWidth;
    const target = (index / 4) * totalScroll;
    window.scrollTo({ top: target, behavior: 'smooth' });
}

// --- CART LOGIC ---
const cartDrawer = document.getElementById('cart-drawer');
const cartBackdrop = document.getElementById('cart-backdrop');
const cartBtn = document.getElementById('cart-btn');
const closeCartBtn = document.getElementById('close-cart');
const cartCountBadge = document.getElementById('cart-count');
const cartItemsContainer = document.getElementById('cart-items');
const cartTotalEl = document.getElementById('cart-total');

let cart = []; 
const products = {
    1: { title: "Nutty Hazelnut", price: 24.00, color: "var(--color-tan)" },
    2: { title: "Creamy Caramel", price: 24.00, color: "var(--color-rust)" },
    3: { title: "Classic Espresso", price: 24.00, color: "var(--color-dark)" },
    4: { title: "Very Vanilla", price: 24.00, color: "var(--color-teal)" },
    5: { title: "Choc & Rasp", price: 26.00, color: "#DBA4A4" }
};

function toggleCart(open) {
    if (open) {
        cartDrawer.classList.add('open');
        cartBackdrop.classList.remove('hidden');
        setTimeout(() => cartBackdrop.classList.remove('opacity-0'), 10);
    } else {
        cartDrawer.classList.remove('open');
        cartBackdrop.classList.add('opacity-0');
        setTimeout(() => cartBackdrop.classList.add('hidden'), 300);
    }
}

cartBtn.addEventListener('click', () => toggleCart(true));
closeCartBtn.addEventListener('click', () => toggleCart(false));
cartBackdrop.addEventListener('click', () => toggleCart(false));

window.addToCart = (id) => {
    const product = products[id];
    const existingItem = cart.find(item => item.id === id);
    if (existingItem) existingItem.qty++;
    else cart.push({ id, qty: 1, ...product });
    renderCart();
    toggleCart(true);
};

function renderCart() {
    cartItemsContainer.innerHTML = '';
    let total = 0;
    let count = 0;

    if (cart.length === 0) {
        cartItemsContainer.innerHTML = '<div class="text-center mt-20 font-hand text-3xl text-gray-400 -rotate-6">Sad and empty...</div>';
    } else {
        cart.forEach(item => {
            total += item.price * item.qty;
            count += item.qty;
            const itemEl = document.createElement('div');
            itemEl.className = "flex gap-4 border-b-4 border-black/10 pb-4 items-center";
            itemEl.innerHTML = `
                <div class="w-16 h-16 border-4 border-black shrink-0" style="background-color: ${item.color}"></div>
                <div class="flex-1">
                    <h4 class="font-display text-xl uppercase leading-none">${item.title}</h4>
                    <p class="text-sm font-mono font-bold">$${item.price.toFixed(2)}</p>
                </div>
                <div class="font-mono font-bold text-xl">x${item.qty}</div>
            `;
            cartItemsContainer.appendChild(itemEl);
        });
    }
    cartTotalEl.innerText = '$' + total.toFixed(2);
    cartCountBadge.innerText = count;
    cartCountBadge.classList.toggle('opacity-0', count === 0);
}

// SMOOTHER GLITCH EFFECT
document.querySelectorAll('.glitch-text').forEach(element => {
    const originalText = element.dataset.text;
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890!@#$%^&*";
    element.addEventListener('mouseover', event => {
        let iterations = 0;
        const interval = setInterval(() => {
            event.target.innerText = event.target.innerText.split("")
                .map((letter, index) => {
                    if(index < iterations) return originalText[index];
                    return chars[Math.floor(Math.random() * chars.length)]
                })
                .join("");
            if(iterations >= originalText.length) clearInterval(interval);
            iterations += 1/2; 
        }, 20);
    });
});
